import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const DocumentValidationIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.98828 4.67578C9.98828 4.67578 10.3216 5.00911 10.6549 5.67578C10.6549 5.67578 11.7137 4.00911 12.6549 3.67578"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66193 1.3476C4.99628 1.27708 3.70944 1.46896 3.70944 1.46896C2.89688 1.52706 1.33967 1.98261 1.33968 4.64307C1.3397 7.28091 1.32246 10.5329 1.33968 11.8293C1.33968 12.6214 1.8301 14.4689 3.52754 14.5679C5.59076 14.6883 9.30719 14.7139 11.0123 14.5679C11.4688 14.5422 12.9885 14.1838 13.1808 12.5304C13.3801 10.8176 13.3404 9.62718 13.3404 9.34384"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6653 4.67708C14.6653 6.51803 13.1715 8.01044 11.3287 8.01044C9.48599 8.01044 7.99219 6.51803 7.99219 4.67708C7.99219 2.83614 9.48599 1.34375 11.3287 1.34375C13.1715 1.34375 14.6653 2.83614 14.6653 4.67708Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M4.65234 8.67578H7.31899"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M4.65234 11.3438H9.98566"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
